import React, { createContext, useState } from "react";

interface CancelActionContextType {
  elementId: any;
  setElementId: (elementId: any) => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;
}

export const CancelActionContext = createContext<CancelActionContextType>({
  elementId: null,
  setElementId: () => {},
  showModal: false,
  setShowModal: () => {},
  backendFormErrors: {},
  setBackendFormErrors: () => {},
});

interface CancelActionProviderProps {
  children: React.ReactNode;
}

export const CancelActionProvider: React.FC<CancelActionProviderProps> = ({
  children,
}) => {
  const [elementId, setElementId] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [backendFormErrors, setBackendFormErrors] = useState(null);

  const value = {
    elementId,
    setElementId,
    showModal,
    setShowModal,
    backendFormErrors,
    setBackendFormErrors,
  };
  return (
    <CancelActionContext.Provider value={value}>
      {children}
    </CancelActionContext.Provider>
  );
};
